<template>
  <div class="bankCardBinding">
    <!--顶部导航-->
    <Navbar title="绑定银行卡" :isSpecialBack="true" @goBack="goBack" />
    <!--内容区域-->
    <div class="content">
      <!--银行卡信息-->
      <div class="bank-wrap">
        <div class="bank-tip">
          <img src="@/assets/style/contactInfo-icon.png" alt="" />
          <span>银行卡信息</span>
        </div>
        <!--银行卡输入框-->
        <bank-card-field
          ref="bankCardFieldRef"
          v-model="bankCard"
          label="卡 号"
        />
        <!--银行卡名称-->
        <bank-name-field v-model="bankName" label="银行" />
        <!--手机号-->
        <bank-phone-field label="手机号" v-model="phone" />
        <!--发送验证码-->
        <bank-code-field
          v-if="loanDisbursementMethodFlag == 1"
          ref="codeField"
          label="验证码"
          v-model="code"
          :phone="phone"
        />
      </div>
      <div v-if="loanDisbursementMethodFlag == 1">
        <!--绑定银行卡协议-->
        <protocolField
          v-model="isChecked"
          protocolType="6"
          routerName="bankCardBinding"
          :cardInfo="{ bankCard, bankName }"
        />
      </div>
      <Popup
        ref="popup"
        message="请先阅读并同意相关协议"
        confirmText="同意并继续"
        cancelText="不同意"
        @confirm="handleConfirm"
      />
      <!--确认绑定-->
      <div
        class="confirm-btn"
        :class="{ disabled: disabled }"
        @click="handleConfirmClick"
      >
        确认绑定
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import bankCardField from "@/components/bankcardbinding/bankCardField.vue";
import bankNameField from "@/components/bankcardbinding/bankNameField.vue";
import bankPhoneField from "@/components/bankcardbinding/bankPhoneField.vue";
import bankCodeField from "@/components/bankcardbinding/bankCodeField.vue";
import protocolField from "@/components/protocolField/index.vue";
import Popup from "@/components/Popup/index.vue";
import { bindBankCard, sign, getLoginProtocol } from "@/api/index.js";
import { validateBankCard } from "@/utils/utils.js";
import { getLocalStorageData } from "@/common/index";

export default {
  name: "bankCardBinding",
  components: {
    Navbar,
    bankCardField,
    bankNameField,
    bankPhoneField,
    bankCodeField,
    protocolField,
    Popup,
  },
  data() {
    return {
      isChecked: false,
      bankCard: "",
      bankName: "",
      phone: "",
      code: "",
      type: "",
      bankRouter: "",
      validateBankCard,
      loanDisbursementMethodFlag: "",
      getLocalStorageData,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "selectBank" || from.name == "agreement") {
        console.log("从选择银行或协议跳转");
      } else {
        vm.bankCard = "";
        vm.phone = "";
        vm.bankName = "";
        vm.code = "";
        vm.isChecked = false;
        vm.loanDisbursementMethodFlag =
          getLocalStorageData("lendingModel") || "";
        vm.$refs.codeField?.init();
        vm.$refs.bankCardFieldRef?.init();
      }
    });
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    //同意并继续登录
    handleConfirm() {
      this.isChecked = true;
    },
    async handleConfirmClick() {
      if (this.disabled) {
        return;
      }
      if(this.phone.length != 11){
        this.$toast("请输入正确的手机号");
        return;
      }
      if (!this.validateBankCard(this.bankCard)) {
        this.$toast("请输入正确的银行卡号");
        return;
      }
      if (!this.isChecked && this.loanDisbursementMethodFlag == 1) {
        this.$refs.popup.showPopup();
        return;
      }
      //绑定银行卡前需要先获取协议内容
      let bankParams = {
        type: 6,
        bankNumber: this.bankCard,
        bankName: this.bankName,
      };
      await getLoginProtocol(bankParams).then(() => {});
      const params = {
        bankNumber: this.bankCard,
        bankName: this.bankName,
        phoneNumber: this.phone,
        code: this.code,
      };
      bindBankCard(params).then(async (res) => {
        if (res.code === 2000) {
          if (this.type === "bankBind") {
            this.$store.commit("setBankInfo", {
              bankNumber: this.bankCard,
              bankName: this.bankName,
            });
          }
          if (this.$store.state.bankCardBindingFlag === "1") {
            this.$store.commit("setReceivedBank", {
              bankNumber: this.bankCard,
              bankName: this.bankName,
              id: res.data,
            });
            this.$toast("绑定成功，已为您自动添加至收款账户");
          } else {
            this.$toast("绑定成功");
          }
          this.$store.dispatch("clearBankName");
          this.bankCard = "";
          this.phone = "";
          this.code = "";
          this.isChecked = false;
          this.$refs.codeField?.init();
          if (this.loanDisbursementMethodFlag == 1) {
            //调用签署协议接口
            await sign({
              configIds: this.$store.state.agreementList.map(
                (item) => item.configId,
              ),
            });
          }
          this.$router.back();
        } else {
          this.$toast(res.message || "绑定失败");
        }
      });
    },
  },
  destroyed() {
    this.$store.dispatch("clearBankCardInfo");
    this.removeInterceptor();
  },
  computed: {
    disabled() {
      if (this.loanDisbursementMethodFlag == 1) {
        return !this.phone || !this.code || !this.bankCard || !this.bankName;
      } else {
        return !this.bankCard || !this.bankName || !this.phone;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bankCardBinding {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
}
.content {
  padding: 16px;
  .title {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: #333;
    padding: 2px 0px;
    .span {
      font-size: 12px;
      color: #01abff;
      margin-top: 10px;
    }
  }
  .bank-wrap {
    padding: 14px 16px 16px 16px;
    border-radius: 8px;
    background: #ffffff;
    .bank-tip {
      display: flex;
      align-items: center;
      img {
        width: 8px;
        height: 8px;
        margin-right: 8px;
      }
    }
  }
  .confirm-btn {
    margin-top: 20px;
    height: 48px;
    background: #1d70f7;
    border-radius: 30px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .disabled {
    background: #8eb7fb;
  }
}
</style>
